import { ReactComponent as InfoIcon } from "../../../../assets/svg/icons/info.svg";
import { ReactComponent as ArchiveIcon } from "../../../../assets/svg/icons/archive.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/svg/icons/trashOnboarding.svg";
import { useEditOnboarding } from "../../../../hooks/useEditOnboarding";
import { useTaskCreation } from "../../../../hooks/useTaskCreation";
import "./styles.css";
import { formatDateWithoutHour, formatHour, parseUtcDate } from "../../../../utils/date/formatedDate";

type TableVisualizationRowProps = {
  evaluation: IMicroAreaEvaluation;
  setSelectedId: (e: number) => void;
};

export default function TableEvaluationRow({
  evaluation,
  setSelectedId
}: TableVisualizationRowProps) {

  const created = parseUtcDate(evaluation?.created_at)
  const updated = parseUtcDate(evaluation?.updated_at)

  const statusMap = new Map<string, string>()
  statusMap.set("COMPLETED", "Avaliado")
  statusMap.set("PENDING", "Pendente")
  statusMap.set("CANCELED", "Cancelada")
  statusMap.set("ARCHIVE", "Arquivado")

  const {
    setIdSelected
  } = useEditOnboarding();

  const {
    setModalArchiveEvaluation,
    setModalCancelateEvaluation,
    setTaskId
  } = useTaskCreation();

  return (
    <tr>
      <td>{evaluation.evaluator}</td>
      <td>{evaluation.micro_area_initials}</td>
      <td>{statusMap.get(evaluation.status)}</td>
      <td>
        {created ?
          <>
            {formatDateWithoutHour(created)}
            < br />
            {formatHour(created)}
          </> :
          ""}
      </td>
      <td>
        {updated ?
          <>
            {formatDateWithoutHour(updated)}
            < br />
            {formatHour(updated)}
          </>
          :
          ""}
      </td>
      <td className="infoButton">
        <button title="Ver detalhes" style={{
          display: (evaluation.status == "ARCHIVE" || evaluation.status == "COMPLETED") ? "block" : "none",
          backgroundColor: "transparent"
        }}>
          <InfoIcon
            onClick={() => {
              setSelectedId(evaluation.task_id)
              setIdSelected(evaluation.micro_area_id)
            }}
          />
        </button>
        <button title="Arquivar" style={{
          display: (evaluation.status == "ARCHIVE" || evaluation.status != "COMPLETED") ? "none" : "block", fill: "rgb(77, 77, 77)",
          backgroundColor: "transparent"
        }}>
          <ArchiveIcon
            onClick={() => {
              setTaskId(evaluation.task_id)
              setModalArchiveEvaluation(true)
            }}
          />
        </button>
        <button title="Deletar" style={{
          display: (evaluation.status == "COMPLETED" || evaluation.status == "ARCHIVE" || evaluation.status == "CANCELED") ? "none" : "block",
          backgroundColor: "transparent"
        }}>
          <DeleteIcon
            onClick={() => {
              setTaskId(evaluation.task_id)
              setModalCancelateEvaluation(true)
            }}
          />
        </button>
      </td>
    </tr>
  );
}
